export function isLoggedIn() {
  return document.cookie.includes('login=1')
}
